import { CompetitionApi } from '@/app/pages/sports/football/home/models';
import {
  CompetitionFavoritesService,
  NewTeamFavoritesService,
} from '@/app/services/favorite';
import { RoutingService } from '@/app/services/routing.service';
import { TranslationService } from '@/app/services/translation.service';
import { ELanguage } from '@/app/utils';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MatchFavoriteItemComponent } from '../match-favorite-item/match-favorite-item.component';

@Component({
  selector: 'app-entity-favorite-row',
  standalone: true,
  imports: [RouterLink, TranslateModule, MatchFavoriteItemComponent],
  templateUrl: './entity-favorite-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EntityFavoriteRowComponent {
  private translateService = inject(TranslationService);
  private routingService = inject(RoutingService);

  private competitionFavoritesService = inject(CompetitionFavoritesService);
  private teamFavoritesService = inject(NewTeamFavoritesService);

  entity = input.required<'Team' | 'Competition'>();
  data = input.required<CompetitionApi>();

  expandedItems = signal<boolean>(true);

  toogleExpanded = () => {
    this.expandedItems.update((state) => !state);
  };

  arrowIcon = environment.urlIcon + 'arrow-down-red.svg';

  entityFavorite = computed(() => {
    if (this.entity() === 'Competition') {
      return this.competitionFavoritesService.favoritesService
        .idsCompetitionFavorites()
        .includes(this.data()?.Id);
    } else {
      return this.teamFavoritesService.favoritesService
        .idsTeamFavorites()
        .includes(this.data()?.Id);
    }
  });
  onImgError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = environment.urlIMG + 'default.png';
  }

  getUrlEntity(): string {
    // return this.data().Link;

    if (this.entity() === 'Competition') {
      return this.routingService.getTraslateUrlCompetitionDetails(
        {
          es: this.data().NameTranslation?.['es'],
          en: this.data().NameTranslation?.['en'],
        },
        this.data().Name,
        this.data().Id
      );
    } else {
      return this.routingService.getTraslateUrlTeamDetails(
        {
          es: this.data().NameTranslation?.['es'],
          en: this.data().NameTranslation?.['en'],
        },
        this.data().Name,
        this.data().Id
      );
    }
  }

  getImgFavorite(): string {
    return this.entityFavorite()
      ? environment.urlIcon + 'fav-red.svg'
      : environment.urlIcon + 'fav-grey.svg';
  }

  toogleEntityFavorite() {
    if (this.entity() === 'Competition') {
      this.competitionFavoritesService.deleteCompetitionFavorites(
        this.data().Id
      );
    }
    if (this.entity() === 'Team') {
      this.teamFavoritesService.deleteTeamFavorites(this.data().Id);
    }
  }

  getImgToogleExpanded(): string {
    return environment.urlIcon + 'arrow-down-red.svg';
  }

  getTraduccionName(): string {
    const lang = this.translateService.getLangLocalStorage() as ELanguage;
    const translation = this.data()?.NameTranslation?.[lang];
    return translation?.trim() ? translation : this.data()?.Name!;
  }
  getTraduccionCountryName(): string {
    const lang = this.translateService.getLangLocalStorage() as ELanguage;
    const translation = this.data()?.CountryNameTranslation?.[lang];
    return translation?.trim() ? translation : this.data()?.CountryName!;
  }

  getCountryImg() {
    return this.data().ImageUrl;
  }
}
